<h1 mat-dialog-title class="mb-0">
	<span>{{ termName }}</span>
</h1>

<div mat-dialog-content class="main-content px-2">
	<h4 class="document-name px-3">
		<span class="badge badge-pill badge-secondary my-2 px-3 py-1 status-badge" *ngIf="languageName"
			>{{ languageName }}</span
		>
		<span
			*ngIf="dialogData.state"
			class="badge badge-pill ml-2 my-2 px-3 py-1 status-badge {{ stateBadge }}"
			>{{ stateLabel }} {{ dialogData?.terms?.displayVersion ? dialogData?.terms?.displayVersion : dialogData?.terms?.version }}</span
		>
		<span
			class="badge badge-pill badge-secondary ml-2 my-2 px-3 py-1"
			*ngIf="dialogData?.cluster"
			>{{dialogData?.cluster?.name}} ({{dialogData?.cluster?.clusterId}})</span
		>
	</h4>
	<div class="row mx-0 px-3 pb-2 legal-wrap">
		<iframe class="legal-iframe" [src]="safeData" title="Legal document" style="border: none;"></iframe>
	</div>
</div>

<div mat-dialog-actions class="row justify-content-center">
	<div class="col-4 text-center" *ngIf="dialogData?.download">
		<button
			class="w-100"
			mat-flat-button
			color="primary"
			(click)="download()"
			i18n
			type="button"
		>
			Download
		</button>
	</div>
	<div class="col-4 text-center">
		<button
			class="w-100"
			type="submit"
			mat-flat-button
			mat-dialog-close
			i18n
		>
			Close
		</button>
	</div>
</div>
